import React from 'react';
import { QlfLogo, colorPalette } from '@qualifio/ui-commons';
import { makeStyles } from '@mui/styles';
import { Loyalty } from '../../libs/loyalty';
import { Page, PageBody, PageHeader } from '../../libs/shared/page';
import { QlfPageErrorBoundary } from '../../libs/shared/QlfPageErrorBoundary';
import { TopBar } from '../../libs/shared/layout/TopBar';
import { isInShell } from '../../libs/shell/shell';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
  },
  sidebar: {
    backgroundColor: colorPalette.marine.main,
    width: 50,
  },
  logo: {
    position: 'sticky',
    top: 0,
  },
  page: {
    flex: 1,
  },
}));

export function LoyaltyIndexPage(): React.ReactElement {
  const classes = useStyles();
  const isRenderingSideBar = !isInShell();
  return (
    <div className={classes.root}>
      {isRenderingSideBar && (
        <div className={classes.sidebar}>
          <QlfLogo className={classes.logo} variant="ICON" />
        </div>
      )}
      <Page className={classes.page}>
        <PageHeader>
          <TopBar withLogo={false} />
        </PageHeader>
        <PageBody>
          <QlfPageErrorBoundary>
            <Loyalty />
          </QlfPageErrorBoundary>
        </PageBody>
      </Page>
    </div>
  );
}
